import { createFileRoute } from '@tanstack/react-router';
import { SecurityTopic } from '../screens/company/topics/SecurityTopic';

export const Route = createFileRoute('/t/$tenant/settings/company/security')({
  component: SecurityTopic,
});
